export const HouseFIlter = ({ name, handleFilter, isActive }) => {
  return (
    <div className="my-1 md:my-3 mx-0 font-poppins font-normal text-sm md:text-base leading-6 flex items-center gap-3">
      <input
        className="house-btn absolute overflow-hidden w-01 h-01"
        type="radio"
        name="house"
        id={name}
        onClick={handleFilter}
      />
      <label
        className={[
          'relative py-1 pl-8 cursor-pointer before:content-[""] before:block before:absolute before:left-0 before:w-4 before:h-4 before:border before:border-grStart before:rounded-full',
          isActive ? 'before:bg-gradient-to-r from-grStart to-grEnd' : '',
        ].join(' ')}
        htmlFor={name}>
        {name}
      </label>
    </div>
  );
};
